"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Button } from "./Button";
import useTranslation from "@/hook/useTranslation";
import { useRouter } from "next/navigation";

export default function CarouselHeader() {
  const { t, locale } = useTranslation();
  const router = useRouter();
  const slides = [
    {
      id: 1,
      title: t("corouselTitle1"),
      description: t("corouselDescription1"),
      image: "/images/banner-img-1.jpg",
      buttonText: t("explore"),
      onClickButton: () => {
        router.push(`/${locale}/news`);
      },
    },
    {
      id: 2,
      title: t("corouselTitle2"),
      description: t("corouselDescription2"),
      image: "/images/banner-img-2.jpg",
      buttonText: t("explore"),
      onClickButton: () => {
        router.push(`/${locale}/news`);
      },
    },
    {
      id: 3,
      title: t("corouselTitle3"),
      description: t("corouselDescription3"),
      image: "/images/banner-img-3.jpg",
      buttonText: t("explore"),
      onClickButton: () => {
        router.push(`/${locale}/news`);
      },
    },
  ];
  return (
    <div className="carousel-container">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        className="swiper-container"
        loop={true}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="slide"
              style={{ backgroundImage: `url(/images/banner.png)` }}
            >
              <img className="slide-image" src={slide.image} />
              <h2 className="slide-title">{slide.title}</h2>
              <p className="slide-description">{slide.description}</p>
              {slide.buttonText && slide.onClickButton && (
                <Button
                  type="rich"
                  onClick={slide.onClickButton}
                  className="slide-button"
                >
                  {slide.buttonText}
                </Button>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
